import api from './api.js'

export default {
    get: () => api.get('/subscription').then(res => res.data).catch(e => console.log(e)),
}
